import BigNumber from "bignumber.js";
import { CdfLookup } from "./cdf-lookup";
import { LnLookup } from "./ln-lookup";
import { SqrtTsAndPvs } from "./sqrt-ts-and-pvs";

const SECONDS_PER_YEAR = 31536000;

export class BlackScholes {
  private lnLookup: LnLookup = new LnLookup();
  private cdfLookup: CdfLookup = new CdfLookup();
  private sqrtTsAndPvs: SqrtTsAndPvs = new SqrtTsAndPvs();

  d1d2(tAnnualised: BigNumber, sqrtTs: BigNumber, volatility: BigNumber, spot: BigNumber, strike: BigNumber, rate: BigNumber) {
    const vtSqrt = volatility.decimalMul(sqrtTs);
    const log = this.lnLookup.ln(spot.decimalDiv(strike));
    const v2t = volatility.decimalMul(volatility).divEvm(2).plus(rate).decimalMul(tAnnualised);
    const d1 = log.plus(v2t).decimalDiv(vtSqrt);
    const d2 = d1.minus(vtSqrt);
    return [d1, d2];
  }

  getPrice(isCall: boolean, expiry: number, timeToExpirySec: number, volatility: BigNumber, spot: BigNumber, strike: BigNumber, rate: BigNumber) {
    const tAnnualised = new BigNumber(timeToExpirySec).decimalDiv(new BigNumber(SECONDS_PER_YEAR));
    const [sqrtTs, pvs] = this.getSqrtTsAndPvs(expiry - timeToExpirySec, expiry, rate);
    const [d1, d2] = this.d1d2(tAnnualised, sqrtTs, volatility, spot, strike, rate);
    const strikePV = strike.decimalMul(pvs);
    const spotNd1 = spot.decimalMul(this.cdfLookup.cdf(d1));
    const strikeNd2 = strikePV.decimalMul(this.cdfLookup.cdf(d2));
    const call = strikeNd2.lt(spotNd1) ? spotNd1.minus(strikeNd2) : new BigNumber(0);
    let put = call.plus(strikePV);
    put = spot.lt(put) ? put.minus(spot) : new BigNumber(0);
    return isCall ? call : put;
  }

  getSqrtTsAndPvs(timestamp: number, expiry: number, rate: BigNumber) {
    return this.sqrtTsAndPvs.getSqrtTsAndPvs(timestamp, expiry, rate);
  }
}
